module.exports = __webpack_public_path__ + "img/66261a0.jpg";